<template>
  <div>
    <div class="avatar-image-container" @mouseenter='applyMouseEnter'>
      <img v-if="fileUrlData" :src="fileUrlData" class="avatar-image" alt=''/>
      <lottie-animation
        v-else-if='forOrganization'
        id="lottie-container-org"
        class='organization-animation'
        ref="animation"
        :animationData="require(`@/assets/icons/animations/organization.json`)"
      />
      <lottie-animation
        v-else
        id="lottie-container-person"
        class='avatar-animation'
        ref="animation"
        :animationData="require(`@/assets/icons/animations/avatar.json`)"
      />
    </div>
    <v-btn dense text class="avatar-button" @click="toggleShow" >upload</v-btn>
    <my-upload field="img"
         @crop-success="cropSuccess"
         @crop-upload-success="cropUploadSuccess"
         @crop-upload-fail="cropUploadFail"
         v-model="show"
         :width="300"
         :height="300"
         :noSquare=true
         :noRotate=false
         langType="en">
    </my-upload>
  </div>
</template>

<script>

import myUpload from 'vue-image-crop-upload/upload-2.vue';
import LottieAnimation from 'lottie-web-vue';

export default {
  name: 'AvatarUpload',
  props: {
    initAnimation: {
      required: false,
      default: false,
      type: Boolean,
    },
    fileUrl: {
      required: false,
    },
    forOrganization: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  watch: {
    initAnimation() {
      if (this.initAnimation) {
        this.applyMouseEnter();
      } else {
        this.stopAnimation();
      }
    },
  },
  data() {
    return {
      show: false,
      animationOptions: {},
    };
  },
  components: {
    LottieAnimation,
    'my-upload': myUpload,
  },
  computed: {
    fileUrlData: {
      get() {
        return this.fileUrl;
      },
      set(value) {
        this.$emit('changed', value);
      },
    },
  },
  methods: {
    stopAnimation() {
      if (this.$refs?.animation) {
        this.$refs.animation.stop();
      }
    },
    applyMouseEnter() {
      if (this.$refs?.animation) {
        this.$refs.animation.play();
      }
    },
    toggleShow() {
      this.show = !this.show;
    },
    // eslint-disable-next-line no-unused-vars
    cropSuccess(imgDataUrl, field) {
      this.fileUrlData = imgDataUrl;
    },
    // eslint-disable-next-line no-unused-vars
    cropUploadSuccess(jsonData, field) {
    },
    // eslint-disable-next-line no-unused-vars
    cropUploadFail(status, field) {
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.avatar-image-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .avatar-image {
    max-width: rem(240);
    max-height: rem(240);
    border-radius: 50%;
    border: 1px solid var(--brand-primary);
  }

  .organization-animation,
  .avatar-animation {
    align-items: center;
    max-width: rem(200);
    max-height: rem(200);
    border-radius: 50%;
    border: 1px solid var(--brand-primary);
    display: flex;
    justify-content: center;
    min-width: rem(200);
    min-height: rem(200);
    color: var(--brand-primary);

    &:hover {
      cursor: pointer;
      border: 1px solid rgba(36,190,181,.3);
      background-color: rgba(36,190,181,.1);
    }
  }
}

.v-btn.v-btn--text.avatar-button {
  color: var(--brand-primary) !important;
  margin-top: rem(28);
  font-size: $font-size-sm;
  font-weight: 500;
  letter-spacing: 1.07px;
  line-height: rem(16);
  text-align: center;
  text-transform: uppercase;
  background-color: transparent !important;

  &:hover {
    background-color: rgba(124, 58, 237, 0.1) !important;
  }

  &::before {
    opacity: 0 !important;
  }
}
</style>

<style lang="scss">
@import '~@/assets/styles/design-system';

#lottie-container-person {
  svg {
    transform: scale(0.8) !important;
  }
}

#lottie-container-org {
  svg {
    transform: scale(2) !important;
  }
}

.vicp-icon4:hover {
  transform: none !important;
}

.vicp-step2 {
  .vicp-operate {
    .vicp-operate-btn {
      background-color: var(--brand-primary) !important;
      box-shadow: $shadow-sm !important;
      color: #ffffff !important;
    }
  }
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview .vicp-preview-item span {
  padding-right: rem(10);
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right {
  margin-top: rem(50);
  margin-right: rem(75);
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-webkit-slider-thumb {
  background-color: var(--brand-primary);
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-ms-thumb {
  background-color: var(--brand-primary);
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-webkit-slider-runnable-track {
  background-color: var(--text-tertiary);
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-moz-range-track {
  background-color: var(--text-tertiary);
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-ms-track {
  background-color: var(--text-tertiary);
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-ms-fill-lower {
  background-color: var(--text-tertiary);
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-ms-fill-upper {
  background-color: var(--text-tertiary);
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:focus::-webkit-slider-runnable-track {
  background-color: var(--text-tertiary);
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:focus::-moz-range-track {
  background-color: var(--text-tertiary);
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:focus::-ms-fill-lower {
  background-color: var(--text-tertiary);
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:focus::-ms-fill-upper {
  background-color: var(--text-tertiary);
}

.vue-image-crop-upload .vicp-wrap .vicp-operate a {
  box-sizing: border-box;
  height: rem(32);
  width: rem(86);
  border: 1px solid var(--brand-primary);
  color: var(--brand-primary);
  border-radius: $radius-sm;
  text-transform: uppercase;
  background-color: var(--bg-primary);
  box-shadow: $shadow-sm !important;
  font-size: $font-size-sm;
  font-weight: 500;
  letter-spacing: 1.07px;
  line-height: rem(30);
  text-align: center;
}
</style>
